import AddressAmlDetails from './AddressAmlDetails';

export default AddressAmlDetails;
